import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Typography from "@material-ui/core/Typography"
import { HourReportWorkflow } from "../../api"
import HourReportReviewProcess from "./HourReportReviewProcess"
import { useHourReportWorkflowTranslations } from "./use-translations"

type ConfirmHourReportWorkflowDialogProps = {
  open: boolean
  isSaving: boolean
  workflow: HourReportWorkflow
  reviewRequiresSubmission: boolean
  approvalRequiresChecking: boolean
  onConfirm: () => void
  onClose: () => void
}

const ConfirmHourReportWorkflowDialog = ({
  open,
  isSaving,
  workflow,
  reviewRequiresSubmission,
  approvalRequiresChecking,
  onConfirm,
  onClose,
}: ConfirmHourReportWorkflowDialogProps) => {
  const translations = useHourReportWorkflowTranslations()

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={() => !isSaving && onClose()}
      aria-labelledby="confirm-hour-report-workflow-title"
    >
      <DialogTitle id="confirm-hour-report-workflow-title">{translations.confirmSaveTitle}</DialogTitle>
      <DialogContent>
        <Typography>{translations.confirmSaveText}</Typography>
        {workflow !== HourReportWorkflow.ReportingOnly && (
          <Box mt={3} p={2} bgcolor="action.hover" borderRadius={4}>
            <Typography variant="subtitle2" align="center" gutterBottom>
              {translations.reviewProcessLabel}
            </Typography>
            <HourReportReviewProcess
              workflow={workflow}
              reviewRequiresSubmission={reviewRequiresSubmission}
              approvalRequiresChecking={approvalRequiresChecking}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: "flex-start", padding: "16px 24px" }}>
        <Button color="primary" variant="contained" disabled={isSaving} onClick={onConfirm}>
          {translations.confirmSaveButtonLabel}
        </Button>
        <Button disabled={isSaving} onClick={onClose}>
          {translations.cancelButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmHourReportWorkflowDialog
